import {useController, useFormContext} from "react-hook-form";
import {theme} from "Theme";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const FormRadioGroup = ({
    name: propsName,
    label = "",
    tooltipText = "",
    description = "",
    options = [],
    rules = {},
    containerStyle = {},
    labelStyle: labelStyleProp = {},
    row = false,
    disabled = false,
}) => {
    const {control, trigger} = useFormContext();

    const {
        field: {onChange, name, value},
        fieldState: {error},
    } = useController({
        name: propsName,
        control,
        rules: {...rules},
    });

    const inputLabel = rules && rules["required"] ? `${label} *` : label;

    const getLabel = () => {
        return tooltipText ? (
            <Box display="flex" alignItems="center" marginRight="-8px">
                {inputLabel}
                {
                    <Tooltip title={tooltipText} arrow enterDelay={500}>
                        <InfoOutlinedIcon
                            fontSize="small"
                            sx={{mx: 1, color: "grey.500"}}
                        />
                    </Tooltip>
                }
            </Box>
        ) : (
            inputLabel
        );
    };

    const labelStyle = row ? {lineHeight: 1, ...labelStyleProp} : {labelStyleProp};

    return (
        <FormControl
            fullWidth
            error={Boolean(error)}
            margin={"dense"}
            sx={containerStyle}
        >
            {label ? (
                <FormLabel id={`radio-buttons-group-${label}`} sx={labelStyle}>
                    {getLabel()}
                </FormLabel>
            ) : null}

            {description && (
                <Typography
                    variant="body2"
                    color="textSecondary"
                    fontStyle="italic"
                    sx={{mb: 1}}
                >
                    {description}
                </Typography>
            )}

            <RadioGroup
                aria-labelledby={`radio-buttons-group-${label}`}
                name={name}
                value={value}
                onChange={event => {
                    onChange(event);
                    if (error) trigger(propsName);
                }}
                row={row}
            >
                {options?.map((option, index) => (
                    <FormControlLabel
                        key={index}
                        value={option.value || false}
                        control={<Radio size="small" />}
                        label={option.label}
                        disabled={disabled}
                        sx={{fontSize: theme.typography.fontSize}}
                    />
                ))}
            </RadioGroup>
            {error?.message ? <FormHelperText>{error?.message}</FormHelperText> : null}
        </FormControl>
    );
};

export default FormRadioGroup;
